import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/root/root.routes').then(m => m.routes),
    data: { titleKey: 'Title' },

  },
];


